export default function TopographySection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-teal-50 rounded-full mb-6">
              <span className="text-teal-600 font-semibold text-sm">Problem Properties Welcome</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              We Buy <strong>Problem Properties</strong>
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Many land buyers shy away from challenging properties, but we specialize in them. Whether your land has steep slopes, rocky terrain, poor drainage, or difficult soil conditions, we're interested. We understand that these factors don't diminish the inherent value of your property—they just require different development approaches.
            </p>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-mountain-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Challenging Topography</h3>
                  <p className="text-gray-600">
                    Steep slopes, rocky outcrops, or irregular terrain don't deter us. We have experience working with all types of land formations and understand their potential value.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-water-flash-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Drainage & Soil Issues</h3>
                  <p className="text-gray-600">
                    Poor drainage, flood-prone areas, or problematic soil conditions are challenges we're equipped to handle. We evaluate these factors professionally and make fair offers accordingly.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-road-map-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Access Challenges</h3>
                  <p className="text-gray-600">
                    Limited road access, landlocked parcels, or properties requiring easements are all situations we regularly work with. We understand the legal and practical solutions needed.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="w-full h-[600px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/34ef317c5987e26d7b334da6500ea51a.jpg"
                alt="Land topography and soil conditions"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
